// Recovered compiled webpack factory 16832. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ACTION_SUFFIX: function () {
        return h;
      },
      APP_DIR_ALIAS: function () {
        return k;
      },
      CACHE_ONE_YEAR: function () {
        return T;
      },
      DOT_NEXT_ALIAS: function () {
        return M;
      },
      ESLINT_DEFAULT_DIRS: function () {
        return ee;
      },
      GSP_NO_RETURNED_VALUE: function () {
        return K;
      },
      GSSP_COMPONENT_MEMBER_ERROR: function () {
        return J;
      },
      GSSP_NO_RETURNED_VALUE: function () {
        return G;
      },
      HTML_CONTENT_TYPE_HEADER: function () {
        return n;
      },
      INFINITE_CACHE: function () {
        return w;
      },
      INSTRUMENTATION_HOOK_FILENAME: function () {
        return A;
      },
      JSON_CONTENT_TYPE_HEADER: function () {
        return a;
      },
      MATCHED_PATH_HEADER: function () {
        return s;
      },
      MIDDLEWARE_FILENAME: function () {
        return j;
      },
      MIDDLEWARE_LOCATION_REGEXP: function () {
        return x;
      },
      NEXT_BODY_SUFFIX: function () {
        return g;
      },
      NEXT_CACHE_IMPLICIT_TAG_ID: function () {
        return O;
      },
      NEXT_CACHE_REVALIDATED_TAGS_HEADER: function () {
        return v;
      },
      NEXT_CACHE_REVALIDATE_TAG_TOKEN_HEADER: function () {
        return b;
      },
      NEXT_CACHE_SOFT_TAG_MAX_LENGTH: function () {
        return S;
      },
      NEXT_CACHE_TAGS_HEADER: function () {
        return y;
      },
      NEXT_CACHE_TAG_MAX_ITEMS: function () {
        return R;
      },
      NEXT_CACHE_TAG_MAX_LENGTH: function () {
        return P;
      },
      NEXT_DATA_SUFFIX: function () {
        return _;
      },
      NEXT_INTERCEPTION_MARKER_PREFIX: function () {
        return i;
      },
      NEXT_META_SUFFIX: function () {
        return m;
      },
      NEXT_QUERY_PARAM_PREFIX: function () {
        return o;
      },
      NEXT_RESUME_HEADER: function () {
        return E;
      },
      NON_STANDARD_NODE_ENV: function () {
        return Q;
      },
      PAGES_DIR_ALIAS: function () {
        return C;
      },
      PRERENDER_REVALIDATE_HEADER: function () {
        return l;
      },
      PRERENDER_REVALIDATE_ONLY_GENERATED_HEADER: function () {
        return u;
      },
      PUBLIC_DIR_MIDDLEWARE_CONFLICT: function () {
        return B;
      },
      ROOT_DIR_ALIAS: function () {
        return N;
      },
      RSC_ACTION_CLIENT_WRAPPER_ALIAS: function () {
        return $;
      },
      RSC_ACTION_ENCRYPTION_ALIAS: function () {
        return F;
      },
      RSC_ACTION_PROXY_ALIAS: function () {
        return D;
      },
      RSC_ACTION_VALIDATE_ALIAS: function () {
        return L;
      },
      RSC_CACHE_WRAPPER_ALIAS: function () {
        return U;
      },
      RSC_DYNAMIC_IMPORT_WRAPPER_ALIAS: function () {
        return H;
      },
      RSC_MOD_REF_PROXY_ALIAS: function () {
        return I;
      },
      RSC_PREFETCH_SUFFIX: function () {
        return c;
      },
      RSC_SEGMENTS_DIR_SUFFIX: function () {
        return f;
      },
      RSC_SEGMENT_SUFFIX: function () {
        return d;
      },
      RSC_SUFFIX: function () {
        return p;
      },
      SERVER_PROPS_EXPORT_ERROR: function () {
        return W;
      },
      SERVER_PROPS_GET_INIT_PROPS_CONFLICT: function () {
        return q;
      },
      SERVER_PROPS_SSG_CONFLICT: function () {
        return Y;
      },
      SERVER_RUNTIME: function () {
        return et;
      },
      SSG_FALLBACK_EXPORT_ERROR: function () {
        return Z;
      },
      SSG_GET_INITIAL_PROPS_CONFLICT: function () {
        return z;
      },
      STATIC_STATUS_PAGE_GET_INITIAL_PROPS_ERROR: function () {
        return X;
      },
      TEXT_PLAIN_CONTENT_TYPE_HEADER: function () {
        return r;
      },
      UNSTABLE_REVALIDATE_RENAME_ERROR: function () {
        return V;
      },
      WEBPACK_LAYERS: function () {
        return en;
      },
      WEBPACK_RESOURCE_QUERIES: function () {
        return ea;
      },
    }));
  let r = "text/plain",
    n = "text/html; charset=utf-8",
    a = "application/json; charset=utf-8",
    o = "nxtP",
    i = "nxtI",
    s = "x-matched-path",
    l = "x-prerender-revalidate",
    u = "x-prerender-revalidate-if-generated",
    c = ".prefetch.rsc",
    f = ".segments",
    d = ".segment.rsc",
    p = ".rsc",
    h = ".action",
    _ = ".json",
    m = ".meta",
    g = ".body",
    y = "x-next-cache-tags",
    v = "x-next-revalidated-tags",
    b = "x-next-revalidate-tag-token",
    E = "next-resume",
    R = 128,
    P = 256,
    S = 1024,
    O = "_N_T_",
    T = 31536e3,
    w = 0xfffffffe,
    j = "middleware",
    x = `(?:src/)?${j}`,
    A = "instrumentation",
    C = "private-next-pages",
    M = "private-dot-next",
    N = "private-next-root-dir",
    k = "private-next-app-dir",
    I = "private-next-rsc-mod-ref-proxy",
    L = "private-next-rsc-action-validate",
    D = "private-next-rsc-server-reference",
    U = "private-next-rsc-cache-wrapper",
    H = "private-next-rsc-track-dynamic-import",
    F = "private-next-rsc-action-encryption",
    $ = "private-next-rsc-action-client-wrapper",
    B =
      "You can not have a '_next' folder inside of your public folder. This conflicts with the internal '/_next' route. https://nextjs.org/docs/messages/public-next-folder-conflict",
    z =
      "You can not use getInitialProps with getStaticProps. To use SSG, please remove your getInitialProps",
    q = "You can not use getInitialProps with getServerSideProps. Please remove getInitialProps.",
    Y =
      "You can not use getStaticProps or getStaticPaths with getServerSideProps. To use SSG, please remove getServerSideProps",
    X =
      "can not have getInitialProps/getServerSideProps, https://nextjs.org/docs/messages/404-get-initial-props",
    W =
      "pages with `getServerSideProps` can not be exported. See more info here: https://nextjs.org/docs/messages/gssp-export",
    K =
      "Your `getStaticProps` function did not return an object. Did you forget to add a `return`?",
    G =
      "Your `getServerSideProps` function did not return an object. Did you forget to add a `return`?",
    V =
      "The `unstable_revalidate` property is available for general use.\nPlease use `revalidate` instead.",
    J =
      "can not be attached to a page's component and must be exported from the page. See more info here: https://nextjs.org/docs/messages/gssp-component-member",
    Q =
      'You are using a non-standard "NODE_ENV" value in your environment. This creates inconsistencies in the project and is strongly advised against. Read more: https://nextjs.org/docs/messages/non-standard-node-env',
    Z =
      "Pages with `fallback` enabled in `getStaticPaths` can not be exported. See more info here: https://nextjs.org/docs/messages/ssg-fallback-true-export",
    ee = ["app", "pages", "components", "lib", "src"],
    et = { edge: "edge", experimentalEdge: "experimental-edge", nodejs: "nodejs" },
    er = {
      shared: "shared",
      reactServerComponents: "rsc",
      serverSideRendering: "ssr",
      actionBrowser: "action-browser",
      apiNode: "api-node",
      apiEdge: "api-edge",
      middleware: "middleware",
      instrument: "instrument",
      edgeAsset: "edge-asset",
      appPagesBrowser: "app-pages-browser",
      pagesDirBrowser: "pages-dir-browser",
      pagesDirEdge: "pages-dir-edge",
      pagesDirNode: "pages-dir-node",
    },
    en = {
      ...er,
      GROUP: {
        builtinReact: [er.reactServerComponents, er.actionBrowser],
        serverOnly: [er.reactServerComponents, er.actionBrowser, er.instrument, er.middleware],
        neutralTarget: [er.apiNode, er.apiEdge],
        clientOnly: [er.serverSideRendering, er.appPagesBrowser],
        bundled: [
          er.reactServerComponents,
          er.actionBrowser,
          er.serverSideRendering,
          er.appPagesBrowser,
          er.shared,
          er.instrument,
          er.middleware,
        ],
        appPages: [
          er.reactServerComponents,
          er.serverSideRendering,
          er.appPagesBrowser,
          er.actionBrowser,
        ],
      },
    },
    ea = {
      edgeSSREntry: "__next_edge_ssr_entry__",
      metadata: "__next_metadata__",
      metadataRoute: "__next_metadata_route__",
      metadataImageMeta: "__next_metadata_image_meta__",
    };
}
